import { render } from "./UserNotFound.vue?vue&type=template&id=0465d8b2&scoped=true&ts=true"
import script from "./UserNotFound.vue?vue&type=script&lang=ts"
export * from "./UserNotFound.vue?vue&type=script&lang=ts"

import "./UserNotFound.vue?vue&type=style&index=0&id=0465d8b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0465d8b2"]])

export default __exports__